import Icon from 'veui/components/Icon'
import { IconCompass } from 'dls-icons-vue'

Icon.register('compass', IconCompass)
